import { useMutation } from "react-query";
import { customerBusinessService } from "../../services";

interface IPayload {
  location_id: string | number;
  customer_id: string | number;
  isGuest?: boolean;
}

const addFavorite = async (payload: IPayload) => {
  if (payload.isGuest) {
    const response = await customerBusinessService.guestLocationAddToFavorites({
      locations: [Number(payload.location_id)],
    });
    return response.data.data;
  }

  const data = {
    customer_id: payload.customer_id,
    locations: [payload.location_id],
  };
  const response = await customerBusinessService.locationAddToFavorites(data as any);
  return response.data.data;
};

export default function useAddFavoritesLocation() {
  return useMutation((payload: IPayload) => addFavorite(payload));
}
